<template>
	<div class="navbar-container">
	  <b-navbar
		type="dark"
	  	class="navbar-subcontainer"
	  >
			<b-navbar-nav class="brand-container">
	    	<b-navbar-brand class="brand" href="#" to="/">
					<img src="../../assets/img/isupplier-logo.png" class="img-logo" alt="" @click="resetFilter()">
				</b-navbar-brand>
				<router-link class="link" to="/" v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'"><span>Home</span></router-link>
				<b-nav-item-dropdown class="admin-dropdown" text="Admin" right v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'">
					<b-dropdown-item @click="$router.push('/legalconfig', () => {})">
						<router-link class="admin-link" to="/legalconfig" v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'"><span>Legal</span></router-link>
					</b-dropdown-item>
					<b-dropdown-item @click="$router.push('/user', () => {})">
						<router-link class="admin-link" to="/user" v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'"><span>User</span></router-link>
					</b-dropdown-item>
				</b-nav-item-dropdown>
				<b-nav-item-dropdown class="admin-dropdown" text="Dashboard" right v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'">
					<b-dropdown-item @click="$router.push('/dashboardspm', () => {})">
						<router-link class="admin-link" to="/dashboardspm" v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'"><span>SPM</span></router-link>
					</b-dropdown-item>
					<b-dropdown-item @click="$router.push('/dashboardcsi', () => {})">
						<router-link class="admin-link" to="/dashboardcsi" v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'"><span>CSI</span></router-link>
					</b-dropdown-item>
					<b-dropdown-item @click="$router.push('/dashboardevent', () => {})">
						<router-link class="admin-link" to="/dashboardevent" v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'"><span>Event</span></router-link>
					</b-dropdown-item>
				</b-nav-item-dropdown>
			</b-navbar-nav>

	    <b-navbar-nav class="account-container">
				<b-nav-item class="account-text" @click.prevent="$bvModal.show('login-modal')" v-if="!$store.state.currentUser">Login</b-nav-item>
				<b-nav-item class="account-user" v-if="$store.state.currentUser">Welcome, {{ $store.state.currentUser.email }}</b-nav-item>
				<b-nav-item class="account-logout" @click.prevent="logout" v-if="$store.state.currentUser">Logout</b-nav-item>
			</b-navbar-nav>

			<div class="mobile-menu">
				<b-nav-item-dropdown class="test" text="Menu" right>
          <b-nav-item class="mobile-account-text" @click.prevent="$bvModal.show('login-modal')" v-if="!$store.state.currentUser">Login</b-nav-item>
					<b-nav-item class="mobile-account-user" v-if="$store.state.currentUser">Welcome, {{ $store.state.currentUser.email }}</b-nav-item>
					<b-nav-item class="link-container" v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'">
						<router-link class="mobile-link" to="/"><span>Home</span></router-link>
					</b-nav-item>
					<b-nav-item class="link-container" v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'">
						<router-link class="mobile-link" to="/legalconfig"><span>Legal</span></router-link>
					</b-nav-item>
					<b-nav-item class="link-container" v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'">
						<router-link class="mobile-link" to="/user"><span>User</span></router-link>
					</b-nav-item>
					<b-nav-item v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'">
						<router-link class="mobile-link" to="/dashboardspm"><span>SPM</span></router-link>
					</b-nav-item>
					<b-nav-item v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'">
						<router-link class="mobile-link" to="/dashboardcsi"><span>CSI</span></router-link>
					</b-nav-item>
					<b-nav-item v-if="$store.state.currentUser && $store.state.currentUser.role == 'SIPM'">
						<router-link class="mobile-link" to="/dashboardevent"><span>Event</span></router-link>
					</b-nav-item>
					<b-nav-item class="mobile-account-logout" @click.prevent="logout" v-if="$store.state.currentUser">Logout</b-nav-item>
        </b-nav-item-dropdown>
			</div>
	  </b-navbar>
	</div>
</template>

<script>
export default {
	name: 'Navbar',
	methods: {
		async logout() {
			await this.$store.dispatch('signOut')
			await this.$router.push({ name : 'home'}, () => {})
		},
	}
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/navbar.scss';
</style>
